import '../utils/jquery.dotdotdot.js'

export default function initActualites () {
  $('.card-linkedin-description').each((index, element) => {
    const encodedHTML = $(element).html()
    const decodedHTML = decodeURIComponent(encodedHTML)
    console.log(decodedHTML)

    // Appliquer dotdotdot uniquement à l'élément actuel
    $(element).html(decodedHTML).dotdotdot({
      after: '.card-linkedin-date',
      watch: true
    })
  })
}

function decodeURIComponent (encodedString) {
  return encodedString.replace(/%27/g, '\'')
}
